import { useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

import SopOutcomeDialog from "@/components/crm/SopOutcomeDialog";

export default function OutcomeDialog({ task, cadence, onClose, onDone }) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  if (!task) return null;
  if (task.sop && task.track !== "qualify") return <SopOutcomeDialog task={task} onClose={onClose} onDone={onDone} />;
  const step = (cadence?.steps || []).find((s) => s.id === task.step_id);
  const opts = step?.popup?.options?.length ? step.popup.options : [{ value: "done", label: "Mark done" }];

  const pick = async (o) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/crm/tasks/${task._id}/complete`, { outcome: o.value, note });
      toast.success(data.next_task ? `Next: ${data.next_task.label}` : data.goto?.startsWith("END_") ? "Cadence finished" : "Task done");
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[var(--panel)] border-[var(--border-strong)] max-w-md" data-testid="outcome-dialog">
        <DialogHeader><DialogTitle className="text-base font-medium">{step?.popup?.title || task.label}</DialogTitle></DialogHeader>
        <div className="text-xs text-neutral-500 -mt-2">{task.label}{task.lead_name ? ` · ${task.lead_name}` : ""}</div>
        <textarea className="w-full px-2.5 py-2 rounded border text-sm" rows={3} placeholder="Note (optional)"
          value={note} onChange={(e) => setNote(e.target.value)} data-testid="outcome-note" />
        <div className="flex flex-col gap-1.5">
          {opts.map((o) => (
            <button key={o.value} className="btn justify-between" disabled={busy} onClick={() => pick(o)} data-testid={`outcome-${o.value}`}>
              <span>{o.label}</span>
              {o.goto && <span className="text-[10px] font-mono text-neutral-500">→ {o.goto.startsWith("END_") ? o.goto.slice(4).toLowerCase() : (cadence.steps.find((s) => s.id === o.goto)?.label || o.goto)}</span>}
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
